import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageContainer } from '../page-container/page-container';
import { FallbackUI } from '../error-boundary/fallback-ui';

type Props = {
  debugInfo?: string;
  error: Error | unknown;
};

export const FullPageErrorView: React.FC<Props> = ({ debugInfo, error }) => {
  const { t } = useTranslation();

  return (
    <PageContainer documentTitle={t('errorPage.defaultPageTitle')}>
      <FallbackUI debugInfo={debugInfo} error={error instanceof Error ? error : null} />
    </PageContainer>
  );
};
